var _defs, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp3CalendarFlipFlopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.c{fill:#fff;}.d{fill:#ffefe0;}.e,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.e{fill-rule:evenodd;}.f{fill:#89d9fb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-flip-flop-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 31.2,
    y: 18.29,
    width: 83.87,
    height: 119.81
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 25.2,
    y: 12.29,
    width: 83.87,
    height: 119.81
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 67.14,
    y: 12.29,
    width: 41.93,
    height: 119.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M24.93,8.29H58.77a2.89,2.89,0,0,0,2.79-2.14,5.78,5.78,0,0,1,11.15,0A2.89,2.89,0,0,0,75.5,8.29h33.84"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 25.2,
    y: 25.06,
    width: 83.87,
    height: 52.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 25.2,
    y: 12.29,
    width: 83.87,
    height: 119.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M34.31,115H42.7m5.93,0H57m5.93,0h8.38m5.93,0h8.38m5.93,0H100m-65.64-8.67H42.7m5.93,0H57m5.93,0h8.38m5.93,0h8.38m5.93,0H100M34.31,97.71H42.7m5.93,0H57m5.93,0h8.38m5.93,0h8.38m5.93,0H100M34.31,89H42.7m5.93,0H57m5.93,0h8.38m5.93,0h8.38m5.93,0H100"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 30.93,
    y1: 4.82,
    x2: 30.93,
    y2: 15.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 38.55,
    y1: 4.82,
    x2: 38.55,
    y2: 15.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 46.17,
    y1: 4.82,
    x2: 46.17,
    y2: 15.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 88.1,
    y1: 4.82,
    x2: 88.1,
    y2: 15.12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 95.72,
    y1: 4.82,
    x2: 95.72,
    y2: 15.12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 103.34,
    y1: 4.82,
    x2: 103.34,
    y2: 15.12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 25.2,
    y1: 25.06,
    x2: 109.07,
    y2: 25.06
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 25.2,
    y1: 77.56,
    x2: 109.07,
    y2: 77.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3CalendarFlipFlopIcon);
export default __webpack_public_path__ + "static/media/CP3-calendar-flip-flop-icon.f07f9235b3903b9432e8e970cf239400.svg";
export { ForwardRef as ReactComponent };